<div class="home">
  <!-- Welcome Header -->
  <div class="welcome-header">
    <div class="welcome-content">
      <h1 class="welcome-title">Bem-vindo, <span class="user-name">{{ userData?.name }}</span>!</h1>
      <p class="welcome-date">{{ formattedDate }}</p>
    </div>
    <img src="/assets/images/bib.png" alt="Bib Michelin" class="bib-image" />
  </div>

  <!-- User Actions -->
  <div class="cards-section">
    <h2 class="section-title">
      <mat-icon class="section-icon icon-blue">space_dashboard</mat-icon>
      Acesso Rápido
    </h2>
    <div class="cards-grid">
      <div class="home-card" routerLink="/dashboard">
        <div class="card-icon-wrapper icon-blue">
          <mat-icon>insights</mat-icon>
        </div>
        <div class="card-content">
          <p class="card-title">Dashboard</p>
          <span class="card-description">Visualize métricas e indicadores</span>
        </div>
        <mat-icon class="arrow-icon">chevron_right</mat-icon>
      </div>

      @if (hasPermissions(['CREATE_AUTOMAKER_ORDER']) && !isDistributorUser) {
        <div class="home-card" routerLink="/automakers">
          <div class="card-icon-wrapper icon-blue">
            <mat-icon>add</mat-icon>
          </div>
          <div class="card-content">
            <p class="card-title">Novo Pedido</p>
            <span class="card-description">Criar um novo pedido</span>
          </div>
          <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
      }

      <div class="home-card" routerLink="/orders">
        <div class="card-icon-wrapper icon-blue">
          <mat-icon>shopping_cart</mat-icon>
        </div>
        <div class="card-content">
          <p class="card-title">Acompanhar Pedidos</p>
          <span class="card-description">Gerencie seus pedidos</span>
        </div>
        <mat-icon class="arrow-icon">chevron_right</mat-icon>
      </div>

      <div class="home-card" routerLink="/reports">
        <div class="card-icon-wrapper icon-blue">
          <mat-icon>assessment</mat-icon>
        </div>
        <div class="card-content">
          <p class="card-title">Relatórios</p>
          <span class="card-description">Baixe relatórios e exportações</span>
        </div>
        <mat-icon class="arrow-icon">chevron_right</mat-icon>
      </div>

      @if (isMichelinUser) {
        <div class="home-card" routerLink="/michelin-stock">
          <div class="card-icon-wrapper icon-blue">
            <mat-icon>all_inbox</mat-icon>
          </div>
          <div class="card-content">
            <p class="card-title">Consultar Estoque (Michelin)</p>
            <span class="card-description">Verifique disponibilidade</span>
          </div>
          <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
      }

      @if (isMichelinUser) {
        <div class="home-card" routerLink="/des-stock">
          <div class="card-icon-wrapper icon-blue">
            <mat-icon>inventory_2</mat-icon>
          </div>
          <div class="card-content">
            <p class="card-title">Estoque DES</p>
            <span class="card-description">Estoque dos distribuidores</span>
          </div>
          <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
      }
    </div>
  </div>

  <!-- Management Actions -->
  @if (isMichelinUser) {
    <div class="cards-section">
      <h2 class="section-title">
        <mat-icon class="section-icon icon-amber">admin_panel_settings</mat-icon>
        Administração
      </h2>
      <div class="cards-grid">
        @if (hasPermissions(['LIST_USER'])) {
          <div class="home-card card-management" routerLink="/users">
            <div class="card-icon-wrapper icon-amber">
              <mat-icon>people</mat-icon>
            </div>
            <div class="card-content">
              <p class="card-title">Usuários</p>
              <span class="card-description">Gerencie usuários do sistema</span>
            </div>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
          </div>
        }

        @if (hasPermissions(['LIST_USER_PROFILE'])) {
          <div class="home-card card-management" routerLink="/user-profiles">
            <div class="card-icon-wrapper icon-amber">
              <mat-icon>admin_panel_settings</mat-icon>
            </div>
            <div class="card-content">
              <p class="card-title">Grupos de Usuários</p>
              <span class="card-description">Gerencie permissões e grupos</span>
            </div>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
          </div>
        }

        @if (hasPermissions(['LIST_DEALERSHIP'])) {
          <div class="home-card card-management" routerLink="/dealerships">
            <div class="card-icon-wrapper icon-amber">
              <mat-icon>business</mat-icon>
            </div>
            <div class="card-content">
              <p class="card-title">Concessionárias</p>
              <span class="card-description">Gerencie concessionárias</span>
            </div>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
          </div>
        }

        @if (hasPermissions(['LIST_DISTRIBUTOR'])) {
          <div class="home-card card-management" routerLink="/distributors">
            <div class="card-icon-wrapper icon-amber">
              <mat-icon>storefront</mat-icon>
            </div>
            <div class="card-content">
              <p class="card-title">Distribuidores</p>
              <span class="card-description">Gerencie distribuidores</span>
            </div>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
          </div>
        }

        @if (hasPermissions(['LIST_AUTOMAKER'])) {
          <div class="home-card card-management" routerLink="/automakers">
            <div class="card-icon-wrapper icon-amber">
              <mat-icon>precision_manufacturing</mat-icon>
            </div>
            <div class="card-content">
              <p class="card-title">Montadoras</p>
              <span class="card-description">Gerencie montadoras</span>
            </div>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
          </div>
        }

        <div class="home-card card-management" routerLink="/city-attributes">
          <div class="card-icon-wrapper icon-amber">
            <mat-icon>south_america</mat-icon>
          </div>
          <div class="card-content">
            <p class="card-title">Gestão de Territórios</p>
            <span class="card-description">Configure regiões e áreas</span>
          </div>
          <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
      </div>
    </div>
  }
</div>